import React, { useContext, useEffect, useRef, useState } from 'react';
import { MLSMapContext } from '../../context/MLSMapContext';
import useOutsideClick from '../../hooks/useOutsideClick';
import mls_property_types from '../../constants/mls_property_types.json';

export default function MLSTypeDropdown() {
  const dropdownRef = useRef();

  const {
    typeDropdownVisible,
    setTypeDropdownVisible,
    typeFilter,
    setTypeFilter,
    setCategoryFilter,
  } = useContext(MLSMapContext);

  const [localTypeFilter, setLocalTypeFilter] = useState(typeFilter);

  useEffect(() => {
    setLocalTypeFilter(typeFilter);
  }, [typeFilter]);

  useOutsideClick(dropdownRef, typeDropdownVisible, () => {
    setLocalTypeFilter(typeFilter);
    setTypeDropdownVisible(false);
  });

  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Type</h2>
      <button
        aria-label="Clear Type Dropdown"
        name="Clear Type Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => setTypeDropdownVisible(false)}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs">
        {mls_property_types.map((type, ind) => {
          const isChecked = localTypeFilter.value === type.value;

          return (
            <label key={ind} htmlFor={`filters-type-${type.value}`}>
              <input
                aria-label={`${type.label}`}
                id={`filters-type-${type.value}`}
                type="checkbox"
                checked={isChecked}
                onChange={() => {
                  if (isChecked) setLocalTypeFilter('');
                  else setLocalTypeFilter(type);
                }}
              />
              <p>{type.label}</p>
            </label>
          );
        })}
      </section>
      <section className="dropdown-actions mobile-center">
        <button
          aria-label="Apply Type Filter"
          name="Apply Type Filter"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            if (typeFilter.value !== localTypeFilter.value) {
              setCategoryFilter([]);
            }
            setTypeFilter(localTypeFilter);
            setTypeDropdownVisible(false);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Type Filter"
          name="Clear Type Filter"
          type="button"
          className="btn btn--light"
          onClick={() => {
            setLocalTypeFilter('');
            setTypeFilter('');
            setCategoryFilter([]);
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
